const realpressScheduleTour = () => {
	const formNodes = document.querySelectorAll( 'form.realpress-schedule-tour' );
	if ( ! formNodes ) {
		return;
	}
	for ( let i = 0; i < formNodes.length; i++ ) {
		const formNode = formNodes[ i ];
		const sendMessageNode = formNode.querySelector( 'button.realpress-send-message' );
		const restUrl = REALPRESS_GLOBAL_OBJECT.rest_url || '';
		const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
		sendMessageNode.addEventListener( 'click', function() {
			sendMessageNode.disabled = true;
			sendMessageNode.insertAdjacentHTML( 'afterbegin', '<i class="rp-spinner"></i>' );
			const id = formNode.querySelector( 'input[name="id"]' ).value || '';
			const userId = formNode.querySelector( 'input[name="agent-id"]' ).value || '';
			const emailTarget = formNode.querySelector( 'input[name="email-target"]' ).value || '';
			const ccAdminEmail = formNode.querySelector( 'input[name="cc-admin"]' ).value || '';
			let date = '';
			if ( formNode.querySelector( 'input[name="date"]:checked' ) ) {
				date = formNode.querySelector( 'input[name="date"]:checked' ).value || '';
			}
			const time = formNode.querySelector( 'select[name="time"]' ).value || '';
			let tourType = '';
			if ( formNode.querySelector( 'input[name="tour-type"]:checked' ) ) {
				tourType = formNode.querySelector( 'input[name="tour-type"]:checked' ).value || '';
			}

			const name = formNode.querySelector( 'input[name="name"]' ).value || '';
			const phone = formNode.querySelector( 'input[name="phone"]' ).value || '';
			const email = formNode.querySelector( 'input[name="email"]' ).value || '';
			const message = formNode.querySelector( 'textarea[name="message"]' ).value || '';
			let termsAndConditions;
			const termsAndConditionsNode = formNode.querySelector( 'input[name="terms_and_conditions"]' );
			if ( termsAndConditionsNode ) {
				termsAndConditions = termsAndConditionsNode.checked || false;
			} else {
				termsAndConditions = true;
			}

			const data = {
				id,
				email_target: emailTarget,
				cc_admin: ccAdminEmail,
				user_id: userId,
				date,
				time,
				tour_type: tourType,
				name,
				phone,
				email,
				message,
				terms_and_conditions: termsAndConditions,
			};

			const messageResultNode = formNode.querySelector( '.realpress-message-result' );
			fetch( restUrl + restNamespace + '/schedule-tour', {
				method: 'POST', headers: {
					'Content-Type': 'application/json',
				}, body: JSON.stringify( data ),
			} )
				.then( ( res ) => res.json() )
				.then( ( res ) => {
					if ( res.status === 'error' ) {
						if ( res.msg ) {
							messageResultNode.classList.remove( 'success' );
							messageResultNode.classList.add( 'failed' );
							messageResultNode.innerHTML = `<span>${ res.msg }</span>`;
						}
					} else if ( res.msg ) {
						messageResultNode.classList.remove( 'failed' );
						messageResultNode.classList.add( 'success' );
						messageResultNode.innerHTML = `<span>${ res.msg }</span>`;
					}
				} ).catch( ( err ) => {
					if ( err.msg ) {
						messageNode.classList.add( 'failed' );
						messageNode.classList.add( 'success' );
						messageNode.innerHTML = `<span>${ err.msg }</span>`;
					}
				} ).finally( () => {
					sendMessageNode.disabled = false;
					sendMessageNode.querySelector( 'i.rp-spinner' ).remove();
				} );
		} );
	}
};

export default realpressScheduleTour;
